import { Component, inject, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '@abp/ng.core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface MobileNavItem {
  label: string;
  path: string;
  iconSvg: string;
  disabled?: boolean;
  children?: MobileNavItem[];
  id?: string;
}

@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  standalone: false
})
export class MobileNavbarComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);

  @Input() navItems: MobileNavItem[] = [];

  activeRoute: string = '/';
  openMenuId: string | null = null; // ahora usamos id

  constructor() {
    this.activeRoute = this.router.url;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.activeRoute = event.urlAfterRedirects;
      this.openMenuId = null;
    });
  }

  get isLoggedIn(): boolean {
    return this.authService.isAuthenticated;
  }

  navigateTo(item: MobileNavItem): void {
    if (item.disabled) return;

    if (item.children?.length) {
      this.toggleMenu(item.id ?? item.path);
    } else {
      this.router.navigate([item.path]).catch(err => console.error('Navigation error:', err));
      this.openMenuId = null;
    }
  }

  isActive(path: string): boolean {
    if (!path || path === '#') return false;
    const currentUrl = this.activeRoute.split('?')[0].split('#')[0];
    const pathNoSlash = path.endsWith('/') ? path.slice(0, -1) : path;
    const currentNoSlash = currentUrl.endsWith('/') ? currentUrl.slice(0, -1) : currentUrl;

    // Match exacto siempre es prioridad
    if (pathNoSlash === currentNoSlash) return true;

    // Para evitar que el 'Home' del sommelier (/slug) esté activo en todas las subpáginas,
    // solo permitimos el match parcial (startsWith) si el path tiene más de 1 segmento (ej: /vanina/catalog)
    const segments = pathNoSlash.split('/').filter(s => s).length;
    if (segments <= 1) return false;

    return currentNoSlash.startsWith(pathNoSlash + '/');
  }


  toggleMenu(id: string) {
    this.openMenuId = this.openMenuId === id ? null : id;
  }

  isMenuOpen(id: string): boolean {
    return this.openMenuId === id;
  }

  getSafeIcon(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}
